import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type CreateOpenDockCarrierFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  firstName: string
  lastName: string
  config?: Partial<HttpClientConfig>
}

export function createOpenDockCarrierFactory({
  repository,
}: CreateOpenDockCarrierFactoryDependencies) {
  return async function createOpenDockCarrier({
    shipmentUUID,
    firstName,
    lastName,
    config,
  }: Params) {
    try {
      return await repository.createOpenDockCarrier(shipmentUUID, { firstName, lastName }, config)
    } catch (error) {
      sentry.log(new Error('Could not create OpenDock carrier', { cause: error as Error }))
      throw new Error('Could not create OpenDock carrier', { cause: error as Error })
    }
  }
}

export function createOpenDockCarrier({ shipmentUUID, firstName, lastName, config }: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newCreateOpenDockCarrier = createOpenDockCarrierFactory({ repository })
  return newCreateOpenDockCarrier({ shipmentUUID, firstName, lastName, config })
}
